import { FC } from "react";

const FilledFileIcon: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H10L16 6V18C16 19.1046 15.1046 20 14 20H2C0.895431 20 0 19.1046 0 18V2Z"
        fill="#3C82FD"
      />
      <path
        opacity="0.3"
        d="M10 0L16 6H12C10.8954 6 10 5.10457 10 4V0Z"
        fill="white"
      />
    </svg>
  );
};

export default FilledFileIcon;
